module.exports = __webpack_public_path__ + "media/images/default/shared/header/time-e93ab2d4d394ff58ff27f29b6afcbf2b.svg";